/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ArrowDown, ArrowUp } from './icons';
import './HeaderDropdown.scss';

const HeaderDropdown = ({
  align = 'left',
  children = '',
  containerWidth,
  displayArrow = true,
  onOpen = () => {},
  title
}) => {
  const [expanded, setExpanded] = useState(false);
  const [clicked, setClicked] = useState(false);
  
  const nodeRef = useRef(null);
  const ie11BlurRelatedTarget = useRef(null);
  const onBlurFirst = useRef(null);

  useEffect(() => {
    const onFocusoutForIE11 = (e) => {
      if (onBlurFirst.current === null) {
        onBlurFirst.current = false;
      }
      if (!onBlurFirst.current) {
        ie11BlurRelatedTarget.current = e.relatedTarget;
      }
    };

    const currentNode = nodeRef.current;
    if (currentNode) {
      currentNode.addEventListener('focusout', onFocusoutForIE11, false);
    }

    return () => {
      if (currentNode) {
        currentNode.removeEventListener('focusout', onFocusoutForIE11);
      }
    };
  }, []);

  const onFocus = () => {
    onOpen();
    setExpanded(true);
  };

  const onBlur = (e) => {
    const relatedTarget = e.relatedTarget || ie11BlurRelatedTarget.current;

    if (!nodeRef.current) {
      setExpanded(false);
      setClicked(false);
    } else if (!nodeRef.current.contains(relatedTarget)) {
      setExpanded(false);
      setClicked(false);
    }

    ie11BlurRelatedTarget.current = null;
    if (onBlurFirst.current === null) {
      onBlurFirst.current = true;
    }
  };

  const onClick = () => {
    if (expanded && clicked) {
      setExpanded(false);
      setClicked(false);
    } else if (!expanded) {
      onOpen();
      setExpanded(true);
      setClicked(true);
    } else {
      setClicked(true);
    }
  };

  const contentsClassName = `header-dropdown__contents header-dropdown__contents--${align}`;

  return (
    <span
      tabIndex="0"
      onFocus={onFocus}
      onBlur={onBlur}
      ref={nodeRef}
      className="header-dropdown ask-list-header-menu__dropdown"
    >
      <button
        className="header-dropdown__header"
        type="button"
        onClick={onClick}
      >
        <span className="header-dropdown__title">{title}</span>
        {displayArrow && (
          expanded ? (
            <ArrowUp className="header-dropdown__icon" width="1.6rem" height="1.6rem" />
          ) : (
            <ArrowDown className="header-dropdown__icon" width="1.6rem" height="1.6rem" />
          )
        )}
      </button>
      {expanded && (
        <div
          style={{ width: containerWidth }}
          className={contentsClassName}
        >
          {children}
        </div>
      )}
    </span>
  );
};

HeaderDropdown.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  containerWidth: PropTypes.string,
  displayArrow: PropTypes.bool,
  onOpen: PropTypes.func
};

export default HeaderDropdown;
